function showUp(dom){
    gsap.from(dom,{
        y:'2rem',opacity:0,ease:'none',duration:0.5,
        scrollTrigger:{
            trigger:dom,
            start:'top bottom-=20%',
            end:'+=0',
            toggleActions:'play none none reverse',
        }
    })
}

var wFlag=window.innerWidth>750

$(()=>{
    setTimeout(() => {
        $('.box1_title').css({opacity:1,transform:'translateY(0)'})
    }, 300);

    //box2
    showUp('.box2_title')
    ScrollTrigger.create({
        trigger:'.box2_items',
        start:'top bottom-=20%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        // markers:true,
        animation:gsap.timeline()
            .from('.box2_items div',{opacity:0,y:'2rem',stagger:0.2})
    })
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box3_img',
            start:'top top+=20%',
            end:'+=0%',
            toggleActions:'play none none reverse',
            animation:gsap.timeline()
                .from('.box3_img img',{clipPath:'inset(25%)'})
        })
    }
    
    new Swiper('.box3Swiper', {
        autoplay:true,
        loop:true,
        slidesPerView: wFlag?2:1.125,
        centeredSlides: true,
        pagination: {
            el: '.box3Swiper-pagination',
        },
    })
    if(wFlag){
        showUp('.box3_title')
        ScrollTrigger.create({
            trigger:'.box4',
            start:'top top+=7%',
            end:'+=80%',
            pin:true,
            scrub:1,
            animation:gsap.timeline()
                .to({},{duration:0.2})
                .to('.box4_bg',{x:'23%',scale:0.9})
                .from('.box4_left',{x:'-100%'},'<')
                .to({},{duration:0.2})
        })

        ScrollTrigger.create({
            trigger:'.box5',
            start:'top top+=20%',
            end:'+=0%',
            toggleActions:'play none none reverse',
            animation:gsap.timeline()
                .from('.box5_title',{opacity:0,y:'2rem'})
        })
        ScrollTrigger.create({
            trigger:'.box5',
            start:'top top+=6%',
            end:'+=60%',
            pin:true,
            onUpdate:(self)=>{
                let index = Math.floor(self.progress * 10);
                $('.box5_item').toggleClass('box5Active',index>4)
            }
        })
    }else{
        showUp('.box3_title')
        showUp('.box4_left')
        showUp('.box5_title')
    }

    //box6
    ScrollTrigger.create({
        trigger:'.box6',
        start:wFlag?'top center-=10%':'top center',
        end:'+=35%',
        scrub:1,
        animation:gsap.timeline()
            .from('.box6_bg',{y:wFlag?'-70%':'-75%'})
    })
    ScrollTrigger.create({
        trigger:'.box6',
        start:wFlag?'top top':'top top+=6%',
        end:'+=100%',
        pin:true,
        scrub:1,
        animation:gsap.timeline()
            .to('.box6_svg',{y:'-100%'})
            .to({},{duration:0.2})
    })

    //box7
    if(wFlag){
        showUp('.box7_item div:nth-child(1) p')
        ScrollTrigger.create({
            trigger:'.box7',
            start:'top top+=5%',
            end:'+=120%',
            pin:true,
            scrub:1,
            animation:gsap.timeline()
                .to({},{duration:0.2})
                .from('.box7_item div:nth-child(2)',{y:'125%'})
                .to('.box7_item div:nth-child(1)',{scale:0.85,rotate:'3deg'},'<')
                .to({},{duration:0.2})
        })
    }else{
        showUp('.box7_item div:nth-child(1) p')
        showUp('.box7_item div:nth-child(2) p')
    }
    

    //flavorsSwiper
    new Swiper('.flavorsSwiper', {
        slidesPerView:wFlag?3:1.5,
        centeredSlides: true,
        autoplay:true,
        navigation: {
            nextEl: '.flavorsSwiper-button-next',
            prevEl: '.flavorsSwiper-button-prev',
        }
    })

    //flavors specs package
    showUp('.flavors_title')
    showUp('.specs_img')
    showUp('.package_title')
})